import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className={`ri-book-open-line text-2xl ${scrolled || !isHome ? 'text-primary-500' : 'text-white'}`}></i>
            </div>
            <span
              className={`text-lg font-heading font-bold ${
                scrolled || !isHome ? 'text-foreground-900' : 'text-white'
              }`}
            >
              八仔漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? scrolled || !isHome
                    ? 'text-primary-500'
                    : 'text-white'
                  : scrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-white/80 hover:text-white'
              }`}
            >
              {t('nav.home')}
            </Link>
            <Link
              to="/category/all"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? scrolled || !isHome
                    ? 'text-primary-500'
                    : 'text-white'
                  : scrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-white/80 hover:text-white'
              }`}
            >
              {t('nav.category')}
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? scrolled || !isHome
                    ? 'text-primary-500'
                    : 'text-white'
                  : scrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-white/80 hover:text-white'
              }`}
            >
              {t('nav.about')}
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/comic/quanzhi-fashi"
              className={`hidden sm:inline-flex items-center px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                scrolled || !isHome
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
              }`}
            >
              {t('home.heroCta')}
            </Link>

            <button
              className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
              aria-label="菜单"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl ${scrolled || !isHome ? 'text-foreground-900' : 'text-white'}`}></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="md:hidden pb-4 border-t border-foreground-200/60">
            <div className="flex flex-col gap-1 pt-3">
              <Link
                to="/"
                className="px-2 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-500 rounded-md transition-colors whitespace-nowrap"
              >
                {t('nav.home')}
              </Link>
              <Link
                to="/category/all"
                className="px-2 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-500 rounded-md transition-colors whitespace-nowrap"
              >
                {t('nav.category')}
              </Link>
              <Link
                to="/about"
                className="px-2 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-500 rounded-md transition-colors whitespace-nowrap"
              >
                {t('nav.about')}
              </Link>
              <Link
                to="/comic/quanzhi-fashi"
                className="px-2 py-2.5 text-sm font-medium bg-primary-500 text-white rounded-md whitespace-nowrap mt-1"
              >
                {t('home.heroCta')}
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}